/*
  Component: Phone country flag
  Responsibility: keep the flag and dialling code beside a country select showing whichever
                  country is selected in it.

  Not tied to a section. Any phone field opts in with three hooks — a root, the two things to
  update, and the select driving them:

    <span data-kl-phone-flag>
      <span class="fi fi-us" data-kl-phone-flag-icon></span>
      <span data-kl-phone-flag-code>+1</span>
      <select data-kl-phone-flag-select> … </select>
    </span>

  The select carries the truth. Its options hold the dialling code as their value and the
  country's ISO code in data-kl-careers-iso, so nothing here keeps a table of countries — the
  markup already has one, and duplicating it in JavaScript is how the two drift apart.

  WHY THE FLAG IS NOT AN <img>. The theme already loads flag-icons for the country selector in
  the footer, which draws flags from an fi-<code> class. Reusing it means no second flag source
  and no request per country; the reference's own SVG-per-flag CDN would be a second dependency
  for the same pictures. Swapping one class token is also all this file has to do.

  Everything still works without this script: the select is a real select, it posts the right
  dialling code, and the flag simply stays on the default. Nothing here is load-bearing.
*/

/* Pure: the flag class for an ISO code, or an empty string when there is not one. DOM-free. */
function getFlagClass(isoCode) {
  const value = String(isoCode || '').trim().toLowerCase();

  return /^[a-z]{2}$/.test(value) ? 'fi-' + value : '';
}

function initPhoneFlag(rootElement) {
  const iconElement = rootElement.querySelector('[data-kl-phone-flag-icon]');
  const codeElement = rootElement.querySelector('[data-kl-phone-flag-code]');
  const selectElement = rootElement.querySelector('[data-kl-phone-flag-select]');

  if (!selectElement) return;

  function updateFromSelection() {
    const option = selectElement.options[selectElement.selectedIndex];

    if (!option) return;

    if (codeElement) codeElement.textContent = option.value;

    if (!iconElement) return;

    const flagClass = getFlagClass(option.dataset.klCareersIso);

    if (!flagClass) {
      console.debug('kl-phone-flag: no country code on the selected option', {
        value: option.value,
      });
      return;
    }

    /*
      Only the fi-<code> token is exchanged. The element also carries the component's own class
      and flag-icons' base .fi, and rewriting className wholesale would drop both.
    */
    Array.from(iconElement.classList)
      .filter((token) => token.startsWith('fi-'))
      .forEach((token) => iconElement.classList.remove(token));

    iconElement.classList.add(flagClass);
  }

  selectElement.addEventListener('change', updateFromSelection);

  /*
    Run once on load as well as on change: a browser restoring a selection after a back button
    or a reload does not fire change, and the flag would then describe a country nobody picked.
  */
  updateFromSelection();
}

document.querySelectorAll('[data-kl-phone-flag]').forEach(initPhoneFlag);

// Theme editor: a re-rendered section arrives with fresh, uninitialised markup.
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-phone-flag]').forEach(initPhoneFlag);
});
